import Lottie from 'lottie-react';
import OnlineConsult from '../jsons/online-doctor-consultation.json';


const LottieOnlineConsult = props => {
  return <Lottie animationData={OnlineConsult} loop={false} {...props} />;
};

export default LottieOnlineConsult;
